module.exports = __webpack_public_path__ + "img/xiaozi_info.de2e96c6.png";